var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import mixinClassNames from "../../utilities/mixinClassNames.js";
import { responsiveStyles, mixinStyles, } from "@bookingcom/bui-core/utilities/styles";
import styles from "@bookingcom/bui-core/css/AspectRatio.module.css";
var getAspectRatio = function (ratio) {
    var _a = ratio.split(":"), w = _a[0], h = _a[1];
    return +w / +h;
};
var AspectRatio = function (props) {
    var children = props.children, _a = props.ratio, ratio = _a === void 0 ? "1:1" : _a, className = props.className, attributes = props.attributes, width = props.width, mixin = props.mixin;
    var rootClassNames = classNames(styles.root, className, mixinClassNames(mixin));
    var rootStyle = __assign(__assign({}, responsiveStyles(width, "aspect_ratio", "width")), mixinStyles(mixin));
    var rootAttributes = __assign(__assign({}, attributes), { style: __assign(__assign({}, ((attributes === null || attributes === void 0 ? void 0 : attributes.style) || {})), mixinStyles(mixin)) });
    var wrapperStyle = __assign({}, responsiveStyles(ratio, "aspect_ratio", "padding-top", function (value) { return "".concat((1 / getAspectRatio(value)) * 100, "%"); }));
    return (
    /* Padding applied to inner element to work correctly inside flex
    elements. Otherwise it will take the full height of the parent flex
    element instead of being a ratio to width */
    React.createElement("div", __assign({}, rootAttributes, { style: __assign(__assign({}, ((attributes === null || attributes === void 0 ? void 0 : attributes.style) || {})), rootStyle), className: rootClassNames }),
        React.createElement("div", { className: styles.wrapper, style: wrapperStyle },
            React.createElement("div", { className: styles.inner }, children))));
};
export default AspectRatio;
